import React from "react"
import { FormattedMessage, defineMessages, injectIntl } from "react-intl"
import Select from "react-select"
import PaymentAccount from "../../payment-account/model/paymentaccount"
import IntlProps from "../../state/helpers/IntlProps"
import Location from "../../state/location/Location"
import LoadingSpinner from "../spinner/loading.component"
import { SelectOption } from "../types"

const pAlocationSelectMessages = defineMessages({
    locationSelectPlaceholder: {
        id: "common.select.payment_account_select_location.placeholder",
        defaultMessage: "Select location(s)",
    },
})

type Props = {
    paymentAccounts : PaymentAccount[]
    currentLocationIds? : string[]
    locations : Location[]
    availableLocations : Location[]
    isLoading : boolean
    selectedLocations: string[]
    onSelect(selectedLocations : SelectOption<string>): void
    setHasUnassignedLocations(value : boolean): void
}
const PaymentAccountLocationSelect = (props: Props & IntlProps ) => {

    if(props.isLoading) {
        return <LoadingSpinner/>
    }
    const locationsPaymentAccountsMap = new Map<string, { location: Location, paymentAccount: PaymentAccount }>()
    props.locations?.forEach(loc => {
        const associatedAccount = props.paymentAccounts?.filter(pa => !pa.hasTestSandboxMerchantId())
            .find(pa => pa.getLocationIds().includes(loc.getId()))
        if(associatedAccount) {
            locationsPaymentAccountsMap.set(loc.getId(), {location : loc, paymentAccount : associatedAccount })
        }
    })


    const getLocationLabel = (location: Location) => {

        const locationName = location.getName() + " "
        if(!locationsPaymentAccountsMap.has(location.getId()) ||
            props.currentLocationIds?.includes(location.getId())){
            return locationName
        }
        return <>
            {locationName}
            <i>
                <FormattedMessage
                    id="common.select.payment_account_location.assigned_location_label"
                    defaultMessage="(Already assigned to payment account {paymentAccountName})"
                    values={
                        {
                            paymentAccountName: (locationsPaymentAccountsMap.get(location.getId())?.paymentAccount as PaymentAccount).getName(),
                        }
                    }
                />
            </i>
        </>
    }

    const generateOptions = (location : Location) => {
        if(location.getEnabled()) {
            return {
                value: location.getId(),
                label: getLocationLabel(location),
                isDisabled: locationsPaymentAccountsMap.has(location.getId()) && !props.currentLocationIds?.includes(location.getId())}
        }
        return undefined
    }
    const options = props.locations?.map(generateOptions).filter(option => option !== undefined)

    return (
        <Select
            name="payment-accounts-location-select"
            placeholder={props.intl.formatMessage(pAlocationSelectMessages.locationSelectPlaceholder)}
            searchable={true}
            multi={true}
            options={options}
            value={props.selectedLocations}
            onChange={(selectedLocations) => {
                props.onSelect(selectedLocations)
            }}
        />
    )
}
export default injectIntl(PaymentAccountLocationSelect)


// WEBPACK FOOTER //
// ./src/common/select/PaymentAccountLocationSelect.tsx